import {useMutation} from '@tanstack/react-query';
import {patchAuthRequest} from '../../services/patchAuthRequest';
import {PatchAuthRequestMutationTypes} from './types';

export const usePatchAuthRequestMutation = () =>
	useMutation({
		mutationFn: ({nuControle, observacoes, signal}: PatchAuthRequestMutationTypes) =>
			patchAuthRequest(nuControle, {observacoes}, signal),
	});
